import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import Radium from 'radium';
/* read the signature_pad docs here:
*  https://github.com/szimek/signature_pad */
import SignaturePad from 'signature_pad/dist/signature_pad';
import { semanticColors } from '../../../Globals/styles';

class EditPic extends Component{

  componentDidMount = () => {
    this._dom = ReactDOM.findDOMNode(this);
    this.initCanvas();
  };

  initCanvas = () => {
    this._signaturePad = new SignaturePad(this.refs.canvas);
    var MAX_WIDTH = 800;
    var MAX_HEIGHT = 600;
    this._resWidth = 800;
    this._resHeight = 600;

    if (this._resWidth > this._resHeight) {
      if (this._resWidth > MAX_WIDTH) {
        this._resHeight *= MAX_WIDTH / this._resWidth;
        this._resWidth = MAX_WIDTH;
      }
    } else {
      if (this._resHeight > MAX_HEIGHT) {
        this._resWidth *= MAX_HEIGHT / this._resHeight;
        this._resHeight = MAX_HEIGHT;
      }
    }

    var img = new Image();
    var canvas = this.refs.canvas;
    var ctx = canvas.getContext("2d");
    var src = this.props.pic.original;

    img.crossOrigin = src.startsWith("data:") ? null : "Anonymous";

    img.onload = () => {
      canvas.width = img.width;
      canvas.height = img.height;
      ctx.drawImage( img, 0, 0 ); //ctx.drawImage( img, 0, 0,  this._resWidth, this._resHeight);
    }
    img.src = src;
    // make sure the load event fires for cached images too
    if ( img.complete || img.complete === undefined ) {
        img.src = "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///ywAAAAAAQABAAACAUwAOw==";
        img.src = src;
    }
  };

  changeColor = color => {
    this._signaturePad.penColor = color;
  };

  clearDrawing = () => {
    this._signaturePad.clear()
    this.initCanvas()
  };

  onSave = () => {
    var dataUrl = this._signaturePad.toDataURL("image/jpeg");
    var editedPic = {
      ...this.props.pic,
      original: dataUrl,
      thumbnail: dataUrl
    }
    this.props.onSubmit(editedPic);
  };

  render() {
    const { onClose } = this.props;
    return (
      <div style={styles.body}>
        <div style={styles.height100}>
          <div style={styles.height100}>
              <canvas
                ref="canvas"
                style={styles.canvas}>
              </canvas>
          </div>
          <div className="visible-sm visible-xs text-center text-danger">
              <p>din skærmstørrelse er for lille til at du kan redigere i billedet</p>
              <p>prøv at vend skærmen om</p>
          </div>
        </div>
        <div style={styles.buttonsContainer}>
          <div className="waves-btn wavesHover"
            style={styles.iconsContainer}
            onClick={this.onSave}>
            <i
              className="fa fa-floppy-o"
              aria-hidden="true"
              style={styles.icon}
            ></i>
            <div style={styles.label}>Gem</div>
          </div>
          <div style={styles.divider}></div>
          <div className="waves-btn wavesHover"
              style={styles.iconsContainer}
              onClick={onClose}>
              <i
                className="fa fa-undo"
                aria-hidden="true"
                style={styles.icon}
              ></i>
              <div style={styles.label}>Fortryd</div>
          </div>
          <div style={styles.divider}></div>
          <div className="waves-btn wavesHover"
              style={[styles.iconsContainer, styles.eraserIcon]}
              onClick={this.clearDrawing}>
              <i
                className="fa fa-eraser"
                aria-hidden="true"
                style={styles.icon}
              ></i>
              <div style={styles.label}>Ryd tegning</div>
          </div>
          <div style={styles.divider}></div>
          <div
            style={[styles.iconsContainer, styles.paintContainer]}>
            <i
              className="fa fa-paint-brush waves-btn"
              aria-hidden="true"
              style={[styles.paintIcon, styles.blackBtn]}
              onClick={()=>{this.changeColor('#000')}}>
            </i>
            <i
              className="fa fa-paint-brush btn btn-danger waves-btn"
              aria-hidden="true"
              style={[styles.paintIcon]}
              onClick={()=>{this.changeColor('#d43f3a')}}>
            </i>
            <i
              className="fa fa-paint-brush btn btn-info waves-btn"
              aria-hidden="true"
              style={[styles.paintIcon]}
              onClick={()=>{this.changeColor('#357ebd')}}>
            </i>
            <div style={styles.label}>Skift farve</div>
          </div>
        </div>
      </div>
    );
  }
}
var styles = {
  body: {
    height: '100%'
  },
  canvas : {
    display: 'block',
    marginLeft: 'auto',
    marginRight: 'auto',
    cursor: 'crosshair'
  },
  buttonsContainer: {
    position: 'absolute',
    right: '0',
    top: '60px',
    width: '100%'
  },
  blackBtn: {
    backgroundColor: semanticColors.text,
    color: '#fff'
  },
  marginLeft: {
    marginLeft: '5px'
  },
  height100 : {
    height: '100%'
  },
  iconsContainer: {
    textAlign: 'center',
    float: 'right',
    width: '80px',
    height: '50px',
    padding: '5px'
  },
  iconsContainerActive: {
    color: semanticColors.info
  },
  label: {
    fontSize: '12px',
    marginTop: '4px',
    fontWeight: '600'
  },
  icon: {
    display: 'block',
    fontSize: '22px'
  },
  divider: {
    display: 'inline-block',
    float: 'right',
    width: '1px',
    height: '30px',
    marginTop : '10px',
    backgroundColor: semanticColors.mainBackground
  },
  eraserIcon: {
    width: '120px'
  },
  paintContainer: {
    width: '150px'
  },
  paintIcon: {
    display: 'inline-block',
    width: '27px',
    height: '27px',
    lineHeight: '27px',
    borderRadius: '2px',
    margin: '0px 7px',
    color: semanticColors.default,
    padding: '0'
  }
}

export default Radium(EditPic)



// WEBPACK FOOTER //
// ./src/App/ShortTermProjects/Workplace/Images/edit.jsx